const SelectFields = {
    beds: [{
        name: '0+ Beds',
        value: '0'
    }, {
        name: '1+ Beds',
        value: '1'
    }, {
        name: '2+ Beds',
        value: '2'
    }, {
        name: '3+ Beds',
        value: '3'
    }, {
        name: '4+ Beds',
        value: '4'
    }],
    baths: [{
        name: '0+ Baths',
        value: '0'
    }, {
        name: '1+ Baths',
        value: '1'
    }, {
        name: '2+ Baths',
        value: '2'
    }, {
        name: '3+ Baths',
        value: '3'
    }, {
        name: '4+ Baths',
        value: '4'
    }],
    number: [
        {
            name: "",
            value: ""
        },
        {
            name: 0,
            value: "0"
        },
        {
            name: 1,
            value: "1"
        },
        {
            name: 2,
            value: "2"
        },
        {
            name: 3,
            value: "3"
        },
        {
            name: 4,
            value: "4"
        },
        {
            name: 5,
            value: "5"
        },
        {
            name: 6,
            value: "6"
        },
        {
            name: 7,
            value: "7"
        },
        {
            name: 8,
            value: "8"
        },
        {
            name: 9,
            value: "9"
        },
        {
            name: 10,
            value: "10"
        }
    ],
    price: [
        {
            name: "50,000",
            value: "50000"
        },
        {
            name: "60,000",
            value: "60000"
        },
        {
            name: "70,000",
            value: "70000"
        },
        {
            name: "80,000",
            value: "80000"
        },
        {
            name: "90,000",
            value: "90000"
        },
        {
            name: "100,000",
            value: "100000"
        },
        {
            name: "120,000",
            value: "120000"
        },
        {
            name: "125,000",
            value: "125000"
        },
        {
            name: "130,000",
            value: "130000"
        },
        {
            name: "140,000",
            value: "140000"
        },
        {
            name: "150,000",
            value: "150000"
        },
        {
            name: "160,000",
            value: "160000"
        },
        {
            name: "170,000",
            value: "170000"
        },
        {
            name: "175,000",
            value: "175000"
        },
        {
            name: "180,000",
            value: "180000"
        },
        {
            name: "190,000",
            value: "190000"
        },
        {
            name: "200,000",
            value: "200000"
        },
        {
            name: "210,000",
            value: "210000"
        },
        {
            name: "220,000",
            value: "220000"
        },
        {
            name: "230,000",
            value: "230000"
        },
        {
            name: "240,000",
            value: "240000"
        },
        {
            name: "250,000",
            value: "250000"
        },
        {
            name: "260,000",
            value: "260000"
        },
        {
            name: "270,000",
            value: "270000"
        },
        {
            name: "280,000",
            value: "280000"
        },
        {
            name: "290,000",
            value: "290000"
        },
        {
            name: "300,000",
            value: "300000"
        },
        {
            name: "325,000",
            value: "325000"
        },
        {
            name: "350,000",
            value: "350000"
        },
        {
            name: "375,000",
            value: "375000"
        },
        {
            name: "400,000",
            value: "400000"
        },
        {
            name: "425,000",
            value: "425000"
        },
        {
            name: "450,000",
            value: "450000"
        },
        {
            name: "475,000",
            value: "475000"
        },
        {
            name: "500,000",
            value: "500000"
        },
        {
            name: "550,000",
            value: "550000"
        },
        {
            name: "600,000",
            value: "600000"
        },
        {
            name: "650,000",
            value: "650000"
        },
        {
            name: "700,000",
            value: "700000"
        },
        {
            name: "800,000",
            value: "800000"
        },
        {
            name: "900,000",
            value: "900000"
        },
        {
            name: "1,000,000",
            value: "1000000"
        },
        {
            name: "1,250,000",
            value: "1250000"
        },
        {
            name: "1,500,000",
            value: "1500000"
        },
        {
            name: "1,750,000",
            value: "1750000"
        },
        {
            name: "2,000,000",
            value: "2000000"
        },
        {
            name: "2,500,000",
            value: "2500000"
        },
        {
            name: "3,000,000",
            value: "3000000"
        },
        {
            name: "4,000,000",
            value: "4000000"
        },
        {
            name: "5,000,000",
            value: "5000000"
        },
        {
            name: "7,500,000",
            value: "7500000"
        },
        {
            name: "10,000,000",
            value: "10000000"
        }
    ],
    hours: [{
        name: "06", 
        value: "6"
    },
    {
        name: "07",
        value: "7"
    },
    {
        name: "08",
        value: "8"
    },
    {
        name: "09",
        value: "9"
    },
    {
        name: "10",
        value: "10"
    },
    {
        name: "11",
        value: "11"
    },
    {
        name: "12",
        value: "12"
    },
    {
        name: "13",
        value: "13"
    },
    {
        name: "14",
        value: "14"
    },
    {
        name: "15",
        value: "15"
    },
    {
        name: "16",
        value: "16"
    },
    {
        name: "17",
        value: "17"
    },
    {
        name: "18",
        value: "18"
    },
    {
        name: "19",
        value: "19"
    },
    {
        name: "20",
        value: "20"
    },
    {
        name: "21",
        value: "21"
    },
    {
        name: "22",
        value: "22"
    }],
    minutes: [{
        name: "00",
        value: "0"
    },
    {
        name: "10",
        value: "10"
    },
    {
        name: "20",
        value: "20"
    },
    {
        name: "30",
        value: "30"
    },
    {
        name: "40",
        value: "40"
    },
    {
        name: "50",
        value: "50"
    }],
    dobDay: ["", ...Array.from({ length: 31 }, (_, i) => i + 1)],
    dobMonth: ["", ...Array.from({ length: 12 }, (_, i) => i + 1)],
    dobYear: ["", ...Array.from({ length: 101 }, (_, i) => 2021 - i)],
    countries: ["Afghanistan","Albania","Algeria","Andorra","Angola","Antigua and Barbuda","Argentina","Armenia","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei","Bulgaria","Burkina Faso","Burundi","Côte d'Ivoire","Cabo Verde","Cambodia","Cameroon","Canada","Central African Republic","Chad","Chile","China","Colombia","Comoros","Congo (Congo-Brazzaville)","Costa Rica","Croatia","Cuba","Cyprus","Czechia (Czech Republic)","Democratic Republic of the Congo","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini (fmr. \"Swaziland\")","Ethiopia","Fiji","Finland","France","Gabon","Gambia","Georgia","Germany","Ghana","Greece","Grenada","Guatemala","Guinea","Guinea-Bissau","Guyana","Haiti","Holy See","Honduras","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy","Jamaica","Japan","Jordan","Kazakhstan","Kenya","Kiribati","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Morocco","Mozambique","Myanmar (formerly Burma)","Namibia","Nauru","Nepal","Netherlands","New Zealand","Nicaragua","Niger","Nigeria","North Korea","North Macedonia","Norway","Oman","Pakistan","Palau","Palestine State","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Qatar","Romania","Russia","Rwanda","Saint Kitts and Nevis","Saint Lucia","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Korea","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Sweden","Switzerland","Syria","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States of America","Uruguay","Uzbekistan","Vanuatu","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe"]
};



export default SelectFields;

